// BookTickets/SummaryBox/TicketLine.tsx
import React from 'react'
import cn from 'classnames'
import styles from '../index.module.scss'
import TicketIcon from '../assets/ticket-icon.svg'

import { formatPrice } from '@booking/lib/money'
import { useTranslations } from 'next-intl'
import { variantTranslationKey } from '../../../lib/bookingConfig'

type Props = {
  variant: string
  quantity: number
  normalPrice?: number | null
  price?: number
  hasVoucher?: boolean
  /** When provided, used as the display label instead of looking up t(`variants.${variant}`) */
  label?: string
}

export default function TicketLine({
  variant,
  quantity,
  normalPrice,
  price = 0,
  hasVoucher,
  label: labelProp,
}: Props) {
  const t = useTranslations('booking')

  const showPrice = typeof price === 'number' && price !== 0
  const showNormal = typeof normalPrice === 'number' && !Number.isNaN(normalPrice)

  //const perPerson = quantity > 1 ? ` ${t('ticket.summaryBox.perPerson')}` : ''
  const label = labelProp ?? t(`variants.${variantTranslationKey(variant)}`)

  if (!showPrice && !showNormal) {
    return (
      <div className={cn(styles.ticketLine)}>
        <TicketIcon />x{quantity} - {label}
      </div>
    )
  }

  const priceLine = t.rich('ticket.summaryBox.breakdownItem', {
    variant: label,
    price: normalPrice ? formatPrice(normalPrice * 100) : formatPrice(price * 100),
    discountedPrice: normalPrice ? formatPrice(price * 100) : '',
    perPerson: quantity > 1 ? t('ticket.summaryBox.perPerson') : '',
    priceElement: (chunks) => (
      <span className={cn(styles.normalPrice, normalPrice && !hasVoucher && styles.isDiscounted)}>
        {chunks}
      </span>
    ),
    discountedPriceElement: (chunks) =>
      normalPrice ? <span className={styles.discountedPrice}>{chunks}</span> : <></>,
  })

  return (
    <div className={cn(styles.ticketLine)}>
      <TicketIcon />x{quantity} - {priceLine}
    </div>
  )
}
